import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import owaCommonStrings from 'owa-strings/owa-common-strings';
import owaDateTimeStrings from 'owa-strings/owa-datetime-strings';
import { OptionsCheckbox } from 'owa-options-controls';
import { Label } from 'office-ui-fabric-react/lib/Label';
import updateWorkWeekOption from '../data/mutators/updateWorkWeekOption';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import calculateUpdatedWorkDays from '../utils/calculateUpdatedWorkDays';
import WorkWeekOptionState from '../data/store/schema/WorkWeekOptionState';
import { observer } from 'mobx-react';
import getWorkDays from '../selectors/getWorkDays';

const styles = require('./WorkWeek.scss');
let classNames = require('classnames/bind').bind(styles);

/**
 * Work week setting specifies the work days in the calendar.
 * Default value is 63 (Weekdays)
 */
export default observer(function WorkWeek() {
    const onWorkWeekOptionChange = (weekDay, workDays: number) => (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        const updatedWorkDays = calculateUpdatedWorkDays(checked, workDays, weekDay);
        updateWorkWeekOption(updatedWorkDays);
    };

    const workDays = getWorkDays();

    const workWeekOptions: WorkWeekOptionState[] = [
        {
            key: 1,
            label: owaCommonStrings.sundayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Sunday,
        },
        {
            key: 2,
            label: owaCommonStrings.mondayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Monday,
        },
        {
            key: 4,
            label: owaCommonStrings.tuesdayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Tuesday,
        },
        {
            key: 8,
            label: owaCommonStrings.wednesdayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Wednesday,
        },
        {
            key: 16,
            label: owaCommonStrings.thursdayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Thursday,
        },
        {
            key: 32,
            label: owaCommonStrings.fridayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Friday,
        },
        {
            key: 64,
            label: owaCommonStrings.saturdayAbbreviatedLowercase,
            ariaLabel: owaDateTimeStrings.calendarDayOfWeek_Saturday,
        },
    ];
    return (
        <div>
            <Label>{strings.options_appearance_workWeekLabel}</Label>
            <div className={classNames(styles.workWeek, getRTL() ? styles.rtl : styles.ltr)}>
                {workWeekOptions.map(weekDay => {
                    const isChecked: number = workDays & weekDay.key;
                    return (
                        <OptionsCheckbox
                            ariaLabel={weekDay.ariaLabel}
                            key={weekDay.key}
                            label={weekDay.label}
                            checked={isChecked > 0}
                            onChange={onWorkWeekOptionChange(weekDay, workDays)}
                        />
                    );
                })}
            </div>
        </div>
    );
});
